import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { connect } from 'react-redux';

const DemoteEquipmentDialog = ({
  open,
  column,
  editing,
  setCurrentlyEditing,
  setCurrentEditor,

  promotedEquipmentById,
}) => {
  if (!editing || editing.length <= 0) return null;
  const promotedStagingEquipment = editing.filter((equip) => equip.promoted_equipment_id);
  const promotedEquipmentWithRelationships = editing
    .map((equip) => equip.promoted_equipment_id)
    .filter(Boolean)
    .map((eid) => promotedEquipmentById[eid])
    // Can happen intermittently during promotion
    .filter(Boolean)
    .filter(
      (e) =>
        Object.keys(e.fed_by_equipment).length !== 0 || Object.keys(e.feeds_equipment).length !== 0
    );
  if (promotedStagingEquipment.length <= 0) return null;
  const action = column;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Unpublish</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" component="label" htmlFor="myField">
          {promotedStagingEquipment.length} published equipment will be unpublished
          {Object.keys(promotedEquipmentWithRelationships).length !== 0 ? (
            <div>
              <br />
              The following equipment have outstanding relationships which will be removed:
              <List sx={{ listStyleType: 'disc' }}>
                {promotedEquipmentWithRelationships.map((e) => (
                  <ListItem key={e.equip_id} sx={{ display: 'list-item', padding: 0 }}>
                    <ListItemText primary={e.name} />
                  </ListItem>
                ))}
              </List>
            </div>
          ) : null}
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          onClick={() => action.doClose({ setCurrentlyEditing, setCurrentEditor })}
          color="error"
          disabled={false}
        >
          Abort
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            action.doSave(promotedStagingEquipment);
            action.doClose({ setCurrentlyEditing, setCurrentEditor });
          }}
          color="success"
          disabled={false}
        >
          Unpublish
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  promotedEquipmentById: state.entities.equipment.byId ?? {},
});

export default connect(mapStateToProps)(DemoteEquipmentDialog);
